import { handleToast } from "../modules/handleToast";

class ProductStockNotify {
    constructor() {
        const root = document.querySelector(".product-stock-notify");
        if (!root) return;
        this.init(root);
    }
    
    init(root) {
        this.root = root;
        this.form = this.root.querySelector("form");
        this.loader = this.root.querySelector(".loader");
        this.openSidebarButtons = this.root.querySelectorAll("[js-open-sidebar]");
        this.closeSidebarButtons = this.root.querySelectorAll("[js-close-sidebar]");
        this.sidebarWrapper = this.root.querySelector(".product-stock-notify__sidebar-wrapper");

        this.activeSidebarClass = "-active";

        this.handleEvents();
    }

    handleEvents() {
        if (this.openSidebarButtons.length) {
            this.openSidebarButtons.forEach(button => {
                button.addEventListener("click", this.handleOpenSidebarButtonClick.bind(this));
            });
        }
        if (this.closeSidebarButtons.length) {
            this.closeSidebarButtons.forEach(button => {
                button.addEventListener("click", this.handleCloseSidebarButtonClick.bind(this));
            });
        }
        if (this.form) {
            this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
        }
    }

    handleOpenSidebarButtonClick() {
        this.sidebarWrapper.classList.add(this.activeSidebarClass);
    }

    handleCloseSidebarButtonClick() {
        this.closeSidebar();
    }

    async handleFormSubmit(e) {
        e.preventDefault();
        try {
            const formData = new FormData(this.form);
            formData.append("timestamp", Math.floor(Date.now() / 1000));
            formData.append("nonce", ajax.nonce);
            this.loader.classList.add("-active");

            const req = await fetch(ajax.url, {
                method: "POST",
                body: formData
            });

            const {data} = await req.json();

            const {status, message} = data;

            if (status === "success") {
                this.closeSidebar();
            }

            handleToast(status, message, 5000);

        } catch (error) {
            console.log(error);
        } finally {
            this.loader.classList.remove("-active");
        }
    }

    closeSidebar() {
        this.sidebarWrapper.classList.remove(this.activeSidebarClass);
    }
}

new ProductStockNotify();
